module.exports = __webpack_public_path__ + "media/HORIZON_intro_audio.12936cd2.mp4";